import { Component, Input, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TabRole, TabsService } from '../../../../../../../libs/components/tabs-host/tabs.service';
import { DraftableStateTypes, EDraftableStateType, ProcessSheets, ProductStateTypeColors, TId } from '../../../../../../../models';
import { MockResource } from '../../../../../../../resources';
import { MasterApiService } from '../../../../../../../services/master-api.service';
import { ProductsProcessSheetsEditComponent } from '../../../../../../products/operative/products-process-sheets/products-process-sheets-edit/products-process-sheets-edit.component';
import { GenericCrudEditComponent } from '../../../../../../../libs/components/generic-crud/generic-crud-edit.component';
import { TranslateService } from '@ngx-translate/core';

type ProcessSheetLink = {
  id: TId;
  processSheetId: TId;
  code: string;
  routingName: string;
  version: string;
  documentTypeName: string;
  revisionStateId: number;
}

@Component({
  selector: 'app-work-procedure-links',
  standalone: false,
  templateUrl: './work-procedure-links.component.html',
  styleUrl: './work-procedure-links.component.sass'
})
export class WorkProcedureLinksComponent implements OnInit {
  @Input() workProcedureId?: TId;

  linksResource?: MockResource<ProcessSheetLink>;
  ready: boolean = false;

  processSheetStates = DraftableStateTypes.map(_ => ({ id: _.id, name: this.tr.instant(`enumeration.DraftableStateTypes.${_.name}`) }));

  constructor(private api:MasterApiService, private tabs:TabsService, private tr:TranslateService) { }

  async ngOnInit(): Promise<void> {
    await this.buildLinks();
  }

  buildLinks = async () => {
    if (!this.workProcedureId)
      return;

    const processSheets = await firstValueFrom(this.api.getProcessSheetListRevisionForWorkProcedure(this.workProcedureId));

    const links = processSheets.map(_ => ({
      id: _.id,
      code: _.code,
      processSheetId: _.processSheetId,
      version: _.version,
      routingName: _.routingName,
      documentTypeName: _.documentTypeName,
      revisionStateId: _.revisionStateId,
    }));

    this.linksResource = new MockResource<ProcessSheetLink>('processSheetLinks', links);
    this.ready = true;
  }

  protected async navigateToProcessSheetEditor(processSheet: ProcessSheetLink) {
    const revision = await firstValueFrom(this.api.getProcessSheetListRevision(processSheet.id));
    this.tabs.createTab<GenericCrudEditComponent<ProcessSheets>>(ProductsProcessSheetsEditComponent!, TabRole.EDITION, { inputPrms: {entity: revision} });
  }

  getStateName = (link: ProcessSheetLink): string => {
    return this.processSheetStates.find(_ => _.id === link.revisionStateId)?.name;
  }

  getStateColor = (link: ProcessSheetLink): string => {
    return ProductStateTypeColors[link.revisionStateId as EDraftableStateType] || '';
  }
}
